import React, { Component } from 'react';
import './StatModelMoreInfo.css';
import Table from 'react-bootstrap/Table';
import MoreInfoTables, { requests, tables } from './Tables/MoreInfoTables';

class InnerFunctionalOutcomes extends Component {
    render () {
        return (
          <div>
            <p>
              Table <MoreInfoTables table={tables.FunctionalOutcome} request={requests.Index} /> links the functional outcomes highlighted in the app to academic publications.
            </p>
            <div>
              <MoreInfoTables table={tables.FunctionalOutcome} request={requests.Title} />
              <MoreInfoTables table={tables.FunctionalOutcome} />
            </div>          
          </div> 
          );
    }
}

export default InnerFunctionalOutcomes;